var Interface = [/* ***************common*************** */
{
  name: "upload",
  path: "/system/upload/upFile",
  method: "get",
  desc: "上传文件"
}, {
  name: "uploadList",
  path: "/common/upload-config-list",
  method: "get",
  desc: "获取上传配置列表"
}, {
  name: "getGroupAllUser",
  path: "/system/organ_user/drop-all-down-date",
  method: "get",
  desc: "获取集团下所有用户列表"
}, {
  name: "forgetPassword",
  path: "/password/forget",
  method: "post",
  desc: "忘记密码-申请重置"
}, {
  name: "resetPassword",
  path: "/password/reset",
  method: "put",
  desc: "忘记密码-重置密码"
}, {
  name: "getSecondPassword",
  path: "/password/has-open-sec",
  method: "get",
  desc: "获取是否开启二级密保"
}, {
  name: "checkPassword",
  path: "/password/sec-check",
  method: "post",
  desc: "密保校验"
}, {
  name: "setSecondPassword",
  path: "/system/user/set-sec-passwd",
  method: "put",
  desc: "设置二级密保"
}, /* *************** 首页列表 *************** */
{
  name: "getIndexList",
  path: "/system/home_data/tab_data_list",
  method: "get",
  desc: "获取首页跳转列表数据"
}, {
  name: "getDataList",
  path: "/system/home_data/list",
  method: "get",
  desc: "获取首页统计数据"
}, /* *************** 数据采集  团队成员 *************** */
{
  name: "getTeamUserList",
  path: "/system/team/list",
  method: "get",
  desc: "团队成员列表"
},
//站内信成员
{
  name: "getMessageUserList",
  path: "/system/user/drop-all-down-date",
  method: "get",
  desc: "站内信成员列表"
}, /* *************** 数据采集  质疑管理 *************** */
{
  name: "getAllQuestionList",
  path: "/system/query/all-list",
  method: "get",
  desc: "质疑列表"
}, /* *************** 数据采集  数据导出 *************** */
{
  name: "getExportsAllList",
  path: "/system/export/cate/list",
  method: "get",
  desc: "获取所有数据导出列表"
}, {
  name: "getExportsCenterList",
  path: "/system/export/center/list",
  method: "get",
  desc: "获取分研究中心导出列表"
}, {
  name: "getExportsCenterId",
  path: "/system/export/cate/dm",
  method: "get",
  desc: "获取分研究中心DM id"
}, {
  name: "exportsList",
  path: "/system/export/add",
  method: "post",
  desc: "导出数据"
},
//导出记录
{
  name: "getExportsRecordList",
  path: "/system/export/record/list",
  method: "get",
  desc: "获取导出记录列表"
}, /* *************** 数据采集  实验室管理 *************** */
//实验室检查表
{
  name: "getLaboratoryCheckList",
  path: "/system/lab-tab/list",
  method: "get",
  desc: "获取实验室检查表列表"
}, {
  name: "getLaboratoryCheckTabList",
  path: "/system/lab-tab/show-tab",
  method: "get",
  desc: "获取实验室检查表切换列表"
}, {
  name: "updateLaboratoryTabCheck",
  path: "/system/lab-tab/update-tab",
  method: "put",
  desc: "标记实验室检查表"
}, {
  name: "getLaboratoryCheckVarbList",
  path: "/system/lab-varb/show-varb",
  method: "get",
  desc: "获取实验室检查项列表"
}, {
  name: "updateLaboratoryVarbCheck",
  path: "/system/lab-varb/update-varb",
  method: "put",
  desc: "标记实验室检查项"
},
//映射关系
{
  name: "getLaboratoryMapList",
  path: "/system/lab-map/list-map",
  method: "get",
  desc: "获取映射关系列表"
}, {
  name: "settingMapping",
  path: "/system/lab-map/update-map",
  method: "put",
  desc: "配置映射关系"
}, {
  name: "getLaboratoryMapTabList",
  path: "/system/lab-range/drop-tab",
  method: "get",
  desc: "获取映射关系配置下拉数据域列表"
}, {
  name: "getLaboratoryMapVarbList",
  path: "/system/lab-range/drop-varb",
  method: "get",
  desc: "获取映射关系下拉变量列表"
},
//正常值范围配置
{
  name: "getLaboratoryMapItemList",
  path: "/system/lab-range/list-map-item",
  method: "get",
  desc: "获取实验室列表"
}, {
  name: "getLaboratoryRangeList",
  path: "/system/lab-range/list",
  method: "get",
  desc: "获取正常值范围值列表"
}, {
  name: "getLaboratoryAllCenterList",
  path: "/system/lab-range/drop-center",
  method: "get",
  desc: "获取项目下已授权的中心"
}, {
  name: "settingLaboratoryRange",
  path: "/system/lab-range/update-range",
  method: "put",
  desc: "配置正常值范围"
}, {
  name: "copyRangeMap",
  path: "/system/lab-range/copy-map",
  method: "get",
  desc: "复制实验室检查表"
}, {
  name: "copyRangeVarb",
  path: "/system/lab-range/copy-varb",
  method: "get",
  desc: "复制实验室检查项"
}, {
  name: "deleteLaboratoryRange",
  path: "/system/lab-range/delete-range",
  method: "delete",
  desc: "删除正常值范围"
}, {
  name: "renameRangeMap",
  path: "/system/lab-range/rename-map",
  method: "put",
  desc: "重命名实验室检查表"
}, /* *************** 数据采集  受试者管理 *************** */
{
  name: "getSubjectList",
  path: "/system/subject/list",
  method: "get",
  desc: "获取受试者列表"
}, {
  name: "addSubject",
  path: "/system/subject/add",
  method: "post",
  desc: "添加受试者"
}, {
  name: "editSubject",
  path: "/system/subject/edit",
  method: "put",
  desc: "修改受试者"
}, {
  name: "getSubDetail",
  path: "/system/subject/get-one",
  method: "get",
  desc: "获取受试者详情"
}, {
  name: "getEcrfDownlist",
  path: "/system/subject/drop-down-data",
  method: "get",
  desc: "获取eCRF版本选择数据"
}, {
  name: "getAllStatuslist",
  path: "/system/subject/get-all-status",
  method: "get",
  desc: "获取所有转化状态"
}, {
  name: "batchSDV",
  path: "/system/subject-varb/sub-all-sdv",
  method: "post",
  desc: "批量SDV"
}, {
  name: "batchCheck",
  path: "/system/subject-varb/sub-all-check",
  method: "post",
  desc: "批量核查"
}, {
  name: "batchSign",
  path: "/system/subject-varb/sub-all-sign",
  method: "post",
  desc: "批量签名"
}, {
  name: "batchLock",
  path: "/system/subject-varb/sub-all-lock",
  method: "post",
  desc: "批量锁定"
}, {
  name: "getFieldVisitList",
  path: "/system/subject/visit-detail",
  method: "get",
  desc: "获取受试者下访视列表"
}, {
  name: "getDataAreaList",
  path: "/system/subject/tab-detail",
  method: "get",
  desc: "根据访视uuid获取对应的数据域及状态"
}, {
  name: "getVarbList",
  path: "/system/subject-varb/list",
  method: "get",
  desc: "根据数据域获取变量内容"
}, {
  name: "addSubjectVarb",
  path: "/system/subject-varb/add",
  method: "post",
  desc: "数据采集数据添加"
}, {
  name: "editSubjectVarb",
  path: "/system/subject-varb/edit",
  method: "put",
  desc: "数据采集数据修改"
}, {
  name: "switchSubjectSigntrue",
  path: "/system/subject-varb/sub-sign",
  method: "get",
  desc: "更改受试者签名状态"
}, {
  name: "switchSubjectLock",
  path: "/system/subject-varb/sub-lock",
  method: "get",
  desc: "更改受试者锁定状态"
}, {
  name: "jupmVarb",
  path: "/system/subject-varb/skip-entry-status",
  method: "get",
  desc: "数据域标记已跳过"
}, {
  name: "finishVarb",
  path: "/system/subject-varb/comp-entry-status",
  method: "get",
  desc: "数据域标记完成"
}, {
  name: "sdvVarb",
  path: "/system/subject-varb/tab-sdv",
  method: "get",
  desc: "数据域SDV"
}, {
  name: "checkVarb",
  path: "/system/subject-varb/tab-check",
  method: "get",
  desc: "数据域核查"
}, {
  name: "signatureVarb",
  path: "/system/subject-varb/tab-sign",
  method: "get",
  desc: "数据域签名"
}, {
  name: "lockVarb",
  path: "/system/subject-varb/tab-lock",
  method: "get",
  desc: "数据域锁定"
}, {
  name: "RecoverRecord",
  path: "/system/subject-varb/record-recover",
  method: "get",
  desc: "多记录恢复"
}, {
  name: "delRecord",
  path: "/system/subject-varb/record-del",
  method: "get",
  desc: "多记录删除"
}, {
  name: "getCheckTrack",
  path: "/system/audit-trail/list",
  method: "get",
  desc: "稽查痕迹列表"
}, {
  name: "getLaboratoryData",
  path: "/system/range/show-map-list",
  method: "get",
  desc: "获取实验室选择下拉数据"
}, {
  name: "getLaboratoryList",
  path: "/system/range/show-range",
  method: "get",
  desc: "获取实验室原则列表"
}, {
  name: "delRecord",
  path: "/system/subject-varb/record-del",
  method: "get",
  desc: "多记录删除"
}, {
  name: "getOneTabList",
  path: "/system/subject-varb/get-tab-status",
  method: "get",
  desc: "获取每一条数据域对应列表"
}, {
  name: "sdvArea",
  path: "/system/subject-varb/varb-sdv",
  method: "get",
  desc: "变量SDV"
}, {
  name: "checkArea",
  path: "/system/subject-varb/varb-check",
  method: "get",
  desc: "变量核查"
}, {
  name: "getQuestionList",
  path: "/system/query/list",
  method: "get",
  desc: "质疑列表"
}, {
  name: "addQuestion",
  path: "/system/query/add",
  method: "post",
  desc: "添加质疑"
}, {
  name: "replyQuestion",
  path: "/system/query/reply",
  method: "post",
  desc: "回复质疑"
}, {
  name: "closeQuestion",
  path: "/system/query/close",
  method: "post",
  desc: "质疑关闭和驳回"
}, {
  name: "getReplyQuestionList",
  path: "/system/query/reply-list",
  method: "get",
  desc: "质疑回复列表"
}, {
  name: "getSdList",
  path: "/system/sd/index",
  method: "post",
  desc: "sd列表"
}, {
  name: "addSD",
  path: "/system/sd/add",
  method: "post",
  desc: "添加sd"
}, {
  name: "editSD",
  path: "/system/sd/edit",
  method: "put",
  desc: "修改sd"
}, {
  name: "deleteSD",
  path: "/system/sd/del",
  method: "delete",
  desc: "删除sd"
}, /* *************** 数据采集  逻辑核查 *************** */
{
  name: "getCheckList",
  path: "/system/check/list",
  method: "get",
  desc: "获取核查程序配置列表"
}, {
  name: "addCheck",
  path: "/system/check/add",
  method: "post",
  desc: "新增核查程序配置"
}, {
  name: "editCheck",
  path: "/system/check/edit",
  method: "put",
  desc: "修改核查程序配置"
}, {
  name: "delCheck",
  path: "/system/check/delete",
  method: "delete",
  desc: "删除核查程序配置"
}, {
  name: "importCheck",
  path: "/system/check/import",
  method: "post",
  desc: "导入核查程序配置"
}, {
  name: "exportCheck",
  path: "/system/check/export",
  method: "post",
  desc: "导出核查程序配置"
}, {
  name: "deployCheck",
  path: "/system/check/deploy",
  method: "post",
  desc: "部署到正式环境"
}, {
  name: "getDownVisitList",
  path: "/system/check/visit/select",
  method: "get",
  desc: "获取所有访视下拉列表"
}, {
  name: "getDownDataAreaList",
  path: "/system/check/tab/select",
  method: "get",
  desc: "获取所有的数据域下拉列表"
}, {
  name: "getCheckTemplate",
  path: "/system/check/down",
  method: "get",
  desc: "获取下载逻辑核查配置模板"
}, {
  name: "getVDownarbList",
  path: "/system/check/varb/select",
  method: "get",
  desc: "获取所有的核查变量下拉列表"
}, /* *************** 数据采集  topnav 项目切换 *************** */
{
  name: "getProSwitchList",
  path: "/system/project/switchlist",
  method: "get",
  desc: "获取项目切换列表"
}, {
  name: "setDefaultProject",
  path: "/system/project/set-default",
  method: "put",
  desc: "设置默认项目"
}, {
  name: "switchProject",
  path: "/system/project/switch",
  method: "get",
  desc: "切换项目"
}, /* *************** 数据采集  文件夹管理 *************** */
{
  name: "getFileAuthInfo",
  path: "/system/folder_file/authInfo",
  method: "get",
  desc: "获取文件授权信息"
}, {
  name: "getFolderFileList",
  path: "/system/folder_file/list",
  method: "get",
  desc: "文件夹列表"
}, {
  name: "addFolderFile",
  path: "/system/folder_file/add",
  method: "post",
  desc: "添加文件夹"
}, {
  name: "editFolderFile",
  path: "/system/folder_file/rename",
  method: "put",
  desc: "修改文件夹"
}, {
  name: "delFolderFile",
  path: "/system/folder_file/delete",
  method: "put",
  desc: "删除文件夹"
}, {
  name: "addFile",
  path: "/system/file/add",
  method: "post",
  desc: "添加文件"
}, {
  name: "getAuthInfoList",
  path: "/system/folder_file/authInfo",
  method: "get",
  desc: "获取文件及文件夹授权信息"
}, {
  name: "updateFileAccess",
  path: "/system/folder_file/access",
  method: "post",
  desc: "提交授权人员"
}, {
  name: "addOperationRecord",
  path: "/system/file/do",
  method: "post",
  desc: "添加操作日志"
}, {
  name: "getOperationRecordList",
  path: "/system/file/log",
  method: "get",
  desc: "获取操作日志列表"
}, {
  name: "moveFiles",
  path: "/system/file/move",
  method: "post",
  desc: "文件或文件夹移动"
}, /* *************** 平台搭建 项目授权记录 *************** */
{
  name: "getProjectAuthLog",
  path: "/system/project/user/auth-log",
  method: "get",
  desc: "获取项目授权记录"
}, /* *************** 平台搭建 数据库设计 *************** */
////变量详情
{
  name: "getAreaVarbList",
  path: "/system/crf-varb/list",
  method: "get",
  desc: "获取数据域变量列表"
}, {
  name: "addAreaVarb",
  path: "/system/crf-varb/add",
  method: "post",
  desc: "新增数据域变量"
}, {
  name: "editAreaVarb",
  path: "/system/crf-varb/edit",
  method: "put",
  desc: "修改数据域变量"
}, {
  name: "delAreaVarb",
  path: "/system/crf-varb/delete",
  method: "delete",
  desc: "删除数据域变量"
}, {
  name: "getVarbEditData",
  path: "/system/crf-varb/one",
  method: "get",
  desc: "获取变量修改时的数据"
}, {
  name: "getVarbTypeList",
  path: "/system/crf-varb/drop-down-data",
  method: "get",
  desc: "获取变量类型下拉列表"
},
//项目详情  数据域列表
{
  name: "getDraftDataAreaList",
  path: "/system/crf-table/list",
  method: "get",
  desc: "获取草案数据域列表"
}, {
  name: "addDraftDataArea",
  path: "/system/crf-table/add",
  method: "post",
  desc: "新增草案数据域"
}, {
  name: "editDraftDataArea",
  path: "/system/crf-table/edit",
  method: "put",
  desc: "修改草案数据域"
}, {
  name: "delDraftDataArea",
  path: "/system/crf-table/delete",
  method: "delete",
  desc: "删除草案数据域"
}, {
  name: "getDataAreaVisitDownList",
  path: "/system/crf-table/drop-down-data",
  method: "get",
  desc: "获取访视下拉数据"
},
//项目详情  访视列表
{
  name: "getDraftVisitList",
  path: "/system/crf-visit/list",
  method: "get",
  desc: "获取草案访视列表"
}, {
  name: "addDraftVisit",
  path: "/system/crf-visit/add",
  method: "post",
  desc: "新增草案访视"
}, {
  name: "editDraftVisit",
  path: "/system/crf-visit/edit",
  method: "put",
  desc: "修改草案访视"
}, {
  name: "delDraftVisit",
  path: "/system/crf-visit/delete",
  method: "delete",
  desc: "删除草案访视"
},
//项目详情  数据库构建
{
  name: "uploadeCRFXsl",
  path: "/system/draft/import",
  method: "post",
  desc: "上传数据库构建eCRF"
}, {
  name: "createIsECRF",
  path: "/system/draft/is-build",
  method: "post",
  desc: "检测是否已经建库"
}, {
  name: "deleteECRF",
  path: "/system/draft/clear-build",
  method: "put",
  desc: "清除数据库"
}, {
  name: "getDownloadTemplate",
  path: "/system/draft/download-tml",
  method: "get",
  desc: "获取数据库构建下载模板"
},
//项目搜索
{
  name: "getDefaultProject",
  path: "/system/draft/project-default",
  method: "get",
  desc: "获取数据库默认项目"
}, {
  name: "getDraftProjectList",
  path: "/system/draft/project-list",
  method: "get",
  desc: "获取草案搜索项目李彪"
}, {
  name: "changeProject",
  path: "/system/draft/project-switch",
  method: "put",
  desc: "切换项目"
},
//部署记录
{
  name: "getDeployLog",
  path: "/system/deploy-log/list",
  method: "get",
  desc: "获取数据库构建部署记录"
},
//草案
{
  name: "getDraftList",
  path: "/system/draft/list",
  method: "get",
  desc: "获取数据库草案列表"
}, {
  name: "addDraft",
  path: "/system/draft/add",
  method: "post",
  desc: "新增草案"
}, {
  name: "editDraft",
  path: "/system/draft/edit",
  method: "put",
  desc: "修改草案"
}, {
  name: "publishDraft",
  path: "/system/rel-draft/add",
  method: "post",
  desc: "发布草案eCRF"
}, {
  name: "activeDisabledelDraft",
  path: "/system/draft/change-status",
  method: "put",
  desc: "禁用启用草案"
},
//已发布版本
{
  name: "getPublishList",
  path: "/system/rel-draft/list",
  method: "get",
  desc: "获取数据库已发布列表"
}, {
  name: "deployDraft",
  path: "/system/rel-draft/deploy",
  method: "post",
  desc: "部署依发版eCRF"
}, {
  name: "exportEcrfBlank",
  path: "/system/rel-draft/blank-ecrf",
  method: "get",
  desc: "导出空白eCRF"
}, {
  name: "exportEcrfNote",
  path: "/system/rel-draft/notes-ecrf",
  method: "get",
  desc: "导出注释eCRF"
}, {
  name: "getDraftIsPublis",
  path: "/system/rel-draft/cherk-can-push",
  method: "get",
  desc: "检测是否可以发布草案"
}, /* *************** 平台搭建 用户管理 *************** */
{
  name: "getProUserList",
  path: "/system/plate/user/list",
  method: "get",
  desc: "获取用户列表"
}, {
  name: "addProUser",
  path: "/system/plate/user/add",
  method: "post",
  desc: "添加用户"
}, {
  name: "editProUser",
  path: "/system/plate/user/edit",
  method: "put",
  desc: "修改用户"
}, {
  name: "unbindWeChat",
  path: "/system/plate/user/unbind-weChat",
  method: "put",
  desc: "解除微信绑定"
}, {
  name: "changeProUserStatus",
  path: "/system/plate/user/edit/status",
  method: "put",
  desc: "修改用户状态"
}, {
  name: "getProRoleList",
  path: "/system/plate/user/role",
  method: "get",
  desc: "获取管理用户下的角色"
}, /* *************** 平台搭建 组织管理 *************** */
{
  name: "getCenterList",
  path: "/system/center/list",
  method: "get",
  desc: "获取组织列表"
}, {
  name: "addCenter",
  path: "/system/center/add",
  method: "post",
  desc: "添加组织"
}, {
  name: "editCenter",
  path: "/system/center/edit",
  method: "put",
  desc: "修改组织"
}, {
  name: "delCenter",
  path: "/system/center/delete",
  method: "delete",
  desc: "删除组织"
}, /* *************** 平台搭建 项目管理 *************** */
{
  name: "getProjectList",
  path: "/system/project/list",
  method: "get",
  desc: "获取项目列表"
}, {
  name: "addProject",
  path: "/system/project/add",
  method: "post",
  desc: "添加项目"
}, {
  name: "editProject",
  path: "/system/project/edit",
  method: "put",
  desc: "修改项目"
}, {
  name: "getProjectConnectList",
  path: "/system/project/get-project-link-man",
  method: "get",
  desc: "获取项目中联系人"
}, {
  name: "getProjectDetail",
  path: "/system/project/detail",
  method: "get",
  desc: "获取项目详情"
},
//用户列表
{
  name: "getProjectAuthorizeUser",
  path: "/system/project/user/list",
  method: "get",
  desc: "获取项目下授权的用户"
}, {
  name: "addProjectAuthorizeUser",
  path: "/system/project/user/add",
  method: "post",
  desc: "新增授权用户"
}, {
  name: "removeProjectAuthorizeUser",
  path: "/system/project/user/remove",
  method: "delete",
  desc: "移除授权用户"
}, {
  name: "getProjectAllAuthorizeUser",
  path: "/system/project/user/drop-select-user",
  method: "get",
  desc: "获取项目下所有授权的用户"
}, {
  name: "getProjectAllAuthorizeRole",
  path: "/system/project/user/drop-select-role",
  method: "get",
  desc: "获取项目下所有授权的角色"
}, {
  name: "getauthorization",
  path: "/system/team/preview-auth",
  method: "post",
  desc: "获取授权书"
}, {
  name: "getProjectAllAuthorizeCenter",
  path: "/system/project/user/drop-select-center",
  method: "get",
  desc: "获取项目下所有授权的中心"
},
//中心管理
{
  name: "getProCenterList",
  path: "/system/project/center/list",
  method: "get",
  desc: "获取中心管理列表详情"
}, {
  name: "addProCenter",
  path: "/system/project/center/add",
  method: "post",
  desc: "添加中心"
}, {
  name: "editProCenter",
  path: "/system/project/center/edit",
  method: "put",
  desc: "修改中心"
}, {
  name: "getProCenterDrowList",
  path: "/system/center/listcenter",
  method: "get",
  desc: "获取项目下的所有研究中心"
}, /* *************** 仪表盘数据 *************** */
{
  name: "getGroupList",
  path: "/system/dashboard/data",
  method: "get",
  desc: "获取集团仪表盘列表"
}, {
  name: "getHosList",
  path: "/system/dashboard/hos-data",
  method: "get",
  desc: "获取机构仪表盘列表"
}, /* *************** 系统 公告 *************** */
{
  name: "getNoticeList",
  path: "/system/announce/list",
  method: "get",
  desc: "获取公告列表"
}, {
  name: "getMyNoticeList",
  path: "/system/announce/my-list",
  method: "get",
  desc: "获取我的公告列表"
}, {
  name: "addNotice",
  path: "/system/announce/add",
  method: "post",
  desc: "添加公告"
}, {
  name: "editNotice",
  path: "/system/announce/edit",
  method: "put",
  desc: "修改公告"
}, {
  name: "publishNotice",
  path: "/system/announce/publish",
  method: "put",
  desc: "发布公告"
}, {
  name: "getNoticeDetail",
  path: "/system/announce/one",
  method: "get",
  desc: "获取公告详情"
}, {
  name: "delNotice",
  path: "/system/announce/delete",
  method: "delete",
  desc: "删除公告"
}, {
  name: "setNoticeRead",
  path: "/system/announce/set-read",
  method: "get",
  desc: "设置为已读"
}, {
  name: "getNoticeReadIndex",
  path: "/system/announce/msg-num",
  method: "get",
  desc: "获取公告未读条数"
}, /* *************** 系统 权限 数据权限 *************** */
{
  name: "menuScopeList",
  path: "/system/auth/menuScopeList",
  method: "get",
  desc: "获取数据权限列表"
}, /* *************** 系统 站内信 *************** */
{
  name: "myMessageList",
  path: "/system/sysmessage/my-list",
  method: "get",
  desc: "我的站内信配置列表"
}, {
  name: "sysMessageList",
  path: "/system/sysmessage/list",
  method: "get",
  desc: "站内信配置列表"
}, {
  name: "sysMessageDetail",
  path: "/system/sysmessage/info",
  method: "get",
  desc: "站内信配置详情"
}, {
  name: "addSysMessage",
  path: "/system/sysmessage/add",
  method: "post",
  desc: "发送站内信"
}, {
  name: "delSysMessage",
  path: "/system/sysmessage/delete",
  method: "delete",
  desc: "删除站内信"
}, {
  name: "sysMessageRead",
  path: "/system/sysmessage/setread",
  method: "get",
  desc: "站内信标为已读"
}, {
  name: "sysMessageNum",
  path: "/system/sysmessage/msg-num",
  method: "get",
  desc: "站内信未读数"
}, /* *************** 系统 模板配置 *************** */
{
  name: "sysTemplateList",
  path: "/system/systemp/list",
  method: "get",
  desc: "模板配置列表"
}, {
  name: "sysTemplateDetail",
  path: "/system/systemp/one",
  method: "get",
  desc: "查看模板配置详情"
}, {
  name: "delSysTemplate",
  path: "/system/systemp/delete",
  method: "delete",
  desc: "删除模板"
}, {
  name: "changeUseState",
  path: "/system/systemp/change_status",
  method: "get",
  desc: "切换模板使用状态"
}, {
  name: "addSysTemplate",
  path: "/system/systemp/add",
  method: "post",
  desc: "添加模板"
}, {
  name: "editSysTemplate",
  path: "/system/systemp/edit",
  method: "put",
  desc: "修改模板"
}, /* *************** 系统 系统日志日志 *************** */
{
  name: "systemLogList",
  path: "/system/service_log/list",
  method: "get",
  desc: "系统日志列表"
}, {
  name: "systemLogDetail",
  path: "/system/service_log/detail",
  method: "post",
  desc: "查看系统日志详情"
}, /* *************** 系统 上传文件日志 *************** */
{
  name: "uploadLogList",
  path: "/system/monitor/uploadFileLog/list",
  method: "get",
  desc: "上传文件日志列表"
}, {
  name: "uploadDownList",
  path: "/system/config/uploadCfg/dropData",
  method: "get",
  desc: "上传文件日志下拉列表"
}, {
  name: "uploadLogList",
  path: "/system/monitor/uploadFileLog/list",
  method: "get",
  desc: "上传文件日志列表"
}, /* ***************导出管理*************** */
{
  name: "exportList",
  path: "/system/export/list",
  method: "get",
  desc: "导出列表"
}, /* ***************电子签名*************** */
{
  name: "getSignatureList",
  path: "/system/signature/list",
  method: "get",
  desc: "电子签名列表"
}, {
  name: "addSignature",
  path: "/system/signature/add",
  method: "post",
  desc: "添加电子签名"
}, {
  name: "delSignature",
  path: "/system/signature/delete",
  method: "put",
  desc: "删除签名"
}, {
  name: "editSignature",
  path: "/system/signature/edit",
  method: "put",
  desc: "设置为默认签名"
}, /* ***************系统配置上传配置*************** */
{
  name: "getUploadList",
  path: "/system/config/uploadCfg/list",
  method: "get",
  desc: "获取上传配置列表"
}, {
  name: "editUploadList",
  path: "/system/config/uploadCfg/edit",
  method: "post",
  desc: "修改上传配置"
}, {
  name: "editOnOff",
  path: "/system/config/uploadCfg/onOff",
  method: "get",
  desc: "上传配置状态的修改"
}, /* ***************医学编码*************** */
{
  name: "codingConfList",
  path: "/system/coding/conf/list",
  method: "get",
  desc: "编码配置列表"
}, {
  name: "codingGetTabname",
  path: "/system/coding/get-tab-name",
  method: "get",
  desc: "获取数据域下拉信息"
}, {
  name: "codingGetVarbname",
  path: "/system/coding/get-varb-name",
  method: "get",
  desc: "获取变量下拉信息"
}, {
  name: "codingConfAdd",
  path: "/system/coding/conf/add",
  method: "post",
  desc: "添加编码配置"
}, {
  name: "codingConfEdit",
  path: "/system/coding/conf/edit",
  method: "put",
  desc: "修改编码配置"
}, {
  name: "codingConfDelete",
  path: "/system/coding/conf/delete",
  method: "delete",
  desc: "删除编码配置"
}, {
  name: "codingUpdate",
  path: "/system/coding/update",
  method: "get",
  desc: "编码更新检查暂时检查项"
}, {
  name: "codingList",
  path: "/system/coding/list",
  method: "get",
  desc: "医学编码列表"
}, {
  name: "codingAutoCoding",
  path: "/system/coding/auto-coding",
  method: "get",
  desc: "自动编码"
}, {
  name: "codingEdit",
  path: "/system/coding/edit",
  method: "put",
  desc: "编码"
}, {
  name: "codingShow",
  path: "/system/coding/show",
  method: "get",
  desc: "编码信息"
}, {
  name: "codingSearch",
  path: "/system/coding/search",
  method: "get",
  desc: "编码搜索"
}, /* *************** PD管理-PD在线汇报 *************** */
{
  name: "pdStatus",
  path: "/system/pd/status",
  method: "get",
  desc: "pd状态列表"
}, {
  name: "pdList",
  path: "/system/pd/list",
  method: "get",
  desc: "pd列表"
}, {
  name: "pdAdd",
  path: "/system/pd/add",
  method: "post",
  desc: "pd新增"
}, {
  name: "pdEdit",
  path: "/system/pd/edit",
  method: "put",
  desc: "pd编辑"
}, {
  name: "pdProcess",
  path: "/system/pd/process",
  method: "put",
  desc: "pd处理"
}, {
  name: "pdProcessStatus",
  path: "/system/pd/process/status",
  method: "post",
  desc: "审批通过处理状态"
}, {
  name: "pdDetail",
  path: "/system/pd/detail",
  method: "get",
  desc: "pd详情"
}, {
  name: "getViolatorList",
  path: "/system/pd/list/violation",
  method: "get",
  desc: "违背者列表"
}, {
  name: "pdSubmit",
  path: "/system/pd/submit",
  method: "post",
  desc: "pd提交审批"
}, {
  name: "pdRevoke",
  path: "/system/pd/withdraw",
  method: "post",
  desc: "pd撤回"
}, {
  name: "pdDelete",
  path: "/system/pd/delete",
  method: "delete",
  desc: "pd删除"
}, {
  name: "pdCopy",
  path: "/system/pd/copy",
  method: "post",
  desc: "pd复制"
}, {
  name: "getPdApprovalInfo",
  path: "/system/pd/is_with_draw",
  method: "get",
  desc: "判断pd是否提交过"
}, {
  name: "getProjectCenterList",
  path: "/system/export/center/list",
  method: "get",
  desc: "获取项目下的中心"
}, {
  name: "addAttach",
  path: "/system/pd/add/common_attach",
  method: "post",
  desc: "添加附件"
}, {
  name: "delAttach",
  path: "/system/pd/delete/common_attach",
  method: "delete",
  desc: "删除附件"
}, /* *************** SAE管理 *************** */
{
  name: "saeList",
  path: "/system/sae/list",
  method: "get",
  desc: "SAE列表"
}, {
  name: "saeDetail",
  path: "/system/sae/detail",
  method: "get",
  desc: "SAE详情"
}, {
  name: "saeAddDevice",
  path: "/system/sae/add/device",
  method: "post",
  desc: "SAE新增-器械"
}, {
  name: "saeEditDevice",
  path: "/system/sae/edit/device",
  method: "put",
  desc: "SAE编辑-器械"
}, {
  name: "saeAddDrug",
  path: "/system/sae/add/drug",
  method: "post",
  desc: "SAE新增-药物"
}, {
  name: "saeEditDrug",
  path: "/system/sae/edit/drug",
  method: "put",
  desc: "SAE编辑-药物"
}, {
  name: "saeDelete",
  path: "/system/sae/delete",
  method: "delete",
  desc: "SAE删除"
}, {
  name: "saeSetSusar",
  path: "/system/sae/susar",
  method: "put",
  desc: "标记为susar"
}, {
  name: "saeSubmitApprovalStatus",
  path: "/system/sae/is_with_draw",
  method: "get",
  desc: "判断是否提交过SAE审批"
}, {
  name: "saeSubmitApproval",
  path: "/system/sae/submit",
  method: "post",
  desc: "SAE提交审批"
}, {
  name: "saeCopy",
  path: "/system/sae/copy",
  method: "post",
  desc: "SAE复制"
}, {
  name: "saeRevoke",
  path: "/system/sae/withdraw",
  method: "post",
  desc: "SAE撤销"
}, {
  name: "saeExport",
  path: "/system/sae/export",
  method: "get",
  desc: "SAE导出"
}, {
  name: "getSaeSub",
  path: "/system/sae/sub",
  method: "get",
  desc: "获取此项目下此环境下的受试者"
}, {
  name: "saeCenter",
  path: "/system/sae/center",
  method: "get",
  desc: "医疗机构下拉列表"
}, /* *************** 统计报表 *************** */
{
  name: "statsGroup",
  path: "/system/stats/group",
  method: "get",
  desc: "入组情况"
}, {
  name: "statsProgress",
  path: "/system/stats/progress",
  method: "get",
  desc: "入组进度"
}, {
  name: "statsSdv",
  path: "/system/stats/sdv",
  method: "get",
  desc: "SDV情况"
}, {
  name: "statsQuery",
  path: "/system/stats/query",
  method: "get",
  desc: "疑问情况"
}, /* ***************库存管理*************** */
//出入库列表
{
  name: "getInOutList",
  path: "/system/material_flow/list",
  method: "get",
  desc: "出入库列表"
}, {
  name: "getStockInOutRecord",
  path: "/system/material_flow/get_by_id_list",
  method: "get",
  desc: "根据库存id获取出入库列表"
}, {
  name: "editInOut",
  path: "/system/material_flow/edit",
  method: "put",
  desc: "修改出入库"
}, {
  name: "materialUserList",
  path: "/system/material_flow/user-list",
  method: "get",
  desc: "获取发放人接收人"
},
//库存列表
{
  name: "getMaterialList",
  path: "/system/material/list",
  method: "get",
  desc: "库存列表"
}, {
  name: "addMaterial",
  path: "/system/material/add",
  method: "post",
  desc: "添加库存物资"
}, {
  name: "editMaterial",
  path: "/system/material/edit",
  method: "put",
  desc: "修改库存物资"
}, {
  name: "delMaterial",
  path: "/system/material/delete",
  method: "delete",
  desc: "删除库存物资"
}, {
  name: "inOutMaterial",
  path: "/system/material/add_material",
  method: "post",
  desc: "库存物资出入库"
}, {
  name: "getMaterialCategoryDown",
  path: "/system/material_category/drop-down-data",
  method: "get",
  desc: "物资类型下拉列表"
},
//物资类型
{
  name: "getCategoryList",
  path: "/system/material_category/list",
  method: "get",
  desc: "物资类型列表"
}, {
  name: "getCategoryDetail",
  path: "/system/material_category/one",
  method: "get",
  desc: "物资类型详情"
}, {
  name: "addCategorys",
  path: "/system/material_category/add",
  method: "post",
  desc: "添加物资类型"
}, {
  name: "editCategorys",
  path: "/system/material_category/edit",
  method: "put",
  desc: "修改物资类型"
}, {
  name: "delCategorys",
  path: "/system/material_category/delete",
  method: "delete",
  desc: "删除物资类型"
}, {
  name: "changeCategorysStatus",
  path: "/system/material_category/change-status",
  method: "get",
  desc: "修改物资类型状态"
}, /* *************** 审批配置 *************** */
{
  name: "approvalConfigProjectRole",
  path: "/system/approval/config/project/role",
  method: "get",
  desc: "获取项目管理类角色"
}, {
  name: "approvalConfigList",
  path: "/system/approval/config/listCopy",
  method: "get",
  desc: "审批配置列表"
}, {
  name: "approvalConfigAdd",
  path: "/system/approval/config/add",
  method: "post",
  desc: "审批配置添加"
}, {
  name: "approvalConfigEdit",
  path: "/system/approval/config/edit",
  method: "put",
  desc: "审批配置修改"
}, {
  name: "approvalConfigDelete",
  path: "/system/approval/config/delete",
  method: "delete",
  desc: "审批配置删除"
}, /* *************** 审批管理 *************** */
{
  name: "approvalList",
  path: "/system/approval/manage/list",
  method: "get",
  desc: "审批管理列表"
}, {
  name: "approvalDetails",
  path: "/system/approval/manage/business",
  method: "get",
  desc: "查看审批详情"
}, {
  name: "approvalHandle",
  path: "/system/approval/process",
  method: "post",
  desc: "处理审批"
}, {
  name: "getProjectUserList",
  path: "/system/approval/process/project/user",
  method: "get",
  desc: "审批抄送用户列表"
}, /* *************** 随访管理 *************** */
{
  name: "visitConfList",
  path: "/system/visit/conf/list",
  method: "get",
  desc: "访视窗配置列表"
}, {
  name: "visitConfEdit",
  path: "/system/visit/conf/edit",
  method: "put",
  desc: "访视窗配置编辑"
}, {
  name: "visitList",
  path: "/system/visit/list",
  method: "get",
  desc: "访视列表"
}, {
  name: "visitEdit",
  path: "/system/visit/edit",
  method: "put",
  desc: "跟进访视"
}, {
  name: "visitConfGetbase",
  path: "/system/visit/conf/get-base",
  method: "get",
  desc: "获取基线日期（访视、数据域、变量）"
}, {
  name: "visitConfSetbase",
  path: "/system/visit/conf/set-base",
  method: "put",
  desc: "设置基线日期（访视、数据域、变量）"
}, {
  name: "getVisitNameDrop",
  path: "/system/visit/conf/get-visit-name",
  method: "get",
  desc: "下拉获取访视信息"
}, {
  name: "getVisitTabDrop",
  path: "/system/visit/conf/get-tab-name",
  method: "get",
  desc: "下拉获数据域信息"
}, {
  name: "getVisitVarbDrop",
  path: "/system/visit/conf/get-varb-name",
  method: "get",
  desc: "下拉获取变量"
}, {
  name: "getdictionaries",
  path: "/system/config/dict/data/GetDictData",
  method: "get",
  desc: "下拉获取字典"
}];
export default Interface;